// extracted by mini-css-extract-plugin
export default {"table-container":"item-master_table-container__ircCs"};